<div class="message">
    <h3></h3>
</div>

<div class="page" *ngIf="isData && !isLoading">

    <div class="print-page-usecase page-break" [style]="'height:'+this.useCaseHeight+'px'">
        <div #usecase class="stage-usecase" [ngClass]="{ 'new-style': useNewLayout }">
            <app-sl-use-cases [width]="'100%'" #slusecases [showEditable]="false"
                [accountsStatusData]="accountsStatusData" [sAccount]="sAccount" [sVersion]="sVersion"
                [useNewLayout]="useNewLayout"></app-sl-use-cases>
        </div>
    </div>

    <div class="page-break">
        <div>
            <img *ngIf="getLogo(this.sAccount)!=''" class="print-image-fit" [src]="'/logos/'+getLogo(this.sAccount)">
            <h3>
                Service Landscape View<ng-container *ngIf="this.sAccount!=null">- <span class="aip-primary-color">{{ this.sAccount["name"] }}</span></ng-container>
            </h3>
        </div>
        <mat-divider class="aip-view-divider"></mat-divider>
        <div class="print-page-view" [style]="'height:'+this.viewHeight">
            <div class="stage-view" [style]="'transform:scale(' + this.viewHeightScale + ')'">
                <ng-container *ngIf="useNewLayout; else oldSlViewTemplate">
                    <app-sl-view-new #slview [showEditable]="false" [entitiesData]="entitiesData" [sAccount]="sAccount"
                        [sVersion]="sVersion" entityViewType="landscape" [healthHideEntities]="true"
                        [stackColors]="stackColors"></app-sl-view-new>
                </ng-container>
                <ng-template #oldSlViewTemplate>
                    <app-sl-view #slview [showEditable]="false" [entitiesData]="entitiesData" [sAccount]="sAccount"
                        [sVersion]="sVersion" entityViewType="landscape" [healthHideEntities]="true"></app-sl-view>
                </ng-template>
            </div>
        </div>
    </div>

    <div class="page-break">
        <div>
            <img *ngIf="getLogo(this.sAccount)!=''" class="print-image-fit" [src]="'/logos/'+getLogo(this.sAccount)">
            <h3>
                Service Health Assessment View<ng-container *ngIf="this.sAccount!=null">- <span class="aip-primary-color">{{ this.sAccount["name"] }}</span></ng-container>
            </h3>
        </div>
        <mat-divider class="aip-view-divider"></mat-divider>
        <div class="print-page-healthview" [style]="'height:'+this.healthViewHeight">
            <div class="stage-healthview" [style]="'transform:scale(' + this.healthViewHeightScale + ')'">
                <ng-container *ngIf="useNewLayout; else oldSlHealthViewTemplate">
                    <app-sl-view-new #slhealthview [showEditable]="false" [entitiesData]="entitiesData"
                        [sAccount]="sAccount" [sVersion]="sVersion" entityViewType="health" [healthHideEntities]="true"
                        [stackColors]="stackColors"></app-sl-view-new>
                </ng-container>
                <ng-template #oldSlHealthViewTemplate>
                    <app-sl-view #slhealthview [showEditable]="false" [entitiesData]="entitiesData" [sAccount]="sAccount"
                        [sVersion]="sVersion" entityViewType="health" [healthHideEntities]="true"></app-sl-view>
                </ng-template>
            </div>
        </div>
    </div>

    <div class="page-break">
        <div>
            <img *ngIf="getLogo(this.sAccount)!=''" class="print-image-fit" [src]="'/logos/'+getLogo(this.sAccount)">
            <h3>
                Asset Map<ng-container *ngIf="this.sAccount!=null">- <span class="aip-primary-color">{{ this.sAccount["name"] }}</span></ng-container>
            </h3>
        </div>
        <mat-divider class="aip-view-divider"></mat-divider>
        <div class="print-page-assetmap" [style]="'height:'+this.assetMapHeight+'px'">
            <div #assetmap class="stage-assetmap" [ngClass]="{ 'new-style': useNewLayout }">
                <ng-container *ngIf="useNewLayout; else oldSlAssetMapTemplate">
                    <app-sl-asset-map-new [showEditable]="false" [assetMapData]="assetMapData" [sAccount]="sAccount"
                        [sVersion]="sVersion" [stackColors]="stackColors"></app-sl-asset-map-new>
                </ng-container>
                <ng-template #oldSlAssetMapTemplate>
                    <app-sl-asset-map [showEditable]="false" [assetMapData]="assetMapData" [sAccount]="sAccount"
                        [sVersion]="sVersion"></app-sl-asset-map>
                </ng-template>
            </div>
        </div>
    </div>

</div>
